/**
 * `/` — public marketing landing.
 *
 * Composes the section components from `components/landing/`. Page-level
 * concerns kept here:
 *   - smooth-scroll behaviour for the in-page anchors
 *   - ambient background tone
 *
 * Anchors:
 *   #features      Features section
 *   #how-it-works  HowItWorks section
 *   #faq           Faq section
 *
 * All copy is i18n-driven (`landing` + `common` namespaces).
 */
import { useEffect } from 'react'
import { PublicHeader } from '@/components/landing/PublicHeader'
import { Hero } from '@/components/landing/Hero'
import { TrustStrip } from '@/components/landing/TrustStrip'
import { Features } from '@/components/landing/Features'
import { HowItWorks } from '@/components/landing/HowItWorks'
import { StatsStrip } from '@/components/landing/StatsStrip'
import { Faq } from '@/components/landing/Faq'
import { FinalCta } from '@/components/landing/FinalCta'
import { PublicFooter } from '@/components/landing/PublicFooter'

export default function Landing() {
  // Smooth scroll on the html element while this page is mounted; reset
  // on unmount so the authed app doesn't inherit it.
  useEffect(() => {
    const prev = document.documentElement.style.scrollBehavior
    document.documentElement.style.scrollBehavior = 'smooth'
    return () => { document.documentElement.style.scrollBehavior = prev }
  }, [])

  return (
    <div className="min-h-screen flex flex-col bg-ink">
      <PublicHeader />
      <main className="flex-1">
        <Hero />
        <TrustStrip />
        <Features />
        <HowItWorks />
        <StatsStrip />
        <Faq />
        <FinalCta />
      </main>
      <PublicFooter />
    </div>
  )
}
